import { bootstrapApplication, HAMMER_LOADER, HammerModule } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { AppComponent } from './app/app.component';
import * as Sentry from '@sentry/angular';
import { getBuildHash } from 'shared';
import { environment } from '@environments/stock-app/environment';
import { ApplicationConfig, enableProdMode, importProvidersFrom, mergeApplicationConfig } from '@angular/core';

Sentry.init({
  dsn: environment.sentry,
  environment: environment.name,
  integrations: [
    // Registers and configures the Tracing integration,
    // which automatically instruments your application to monitor its
    // performance, including custom Angular routing instrumentation
    Sentry.browserTracingIntegration(),
    // No Session Replay: it records every DOM change in every session, which nearly doubled the start-up time
    // on the warehouse PDAs.
  ],

  // Set tracesSampleRate to 1.0 to capture 100%
  // of transactions for tracing.
  // We recommend adjusting this value in production
  tracesSampleRate: 1.0,

  // Set `tracePropagationTargets` to control for which URLs trace propagation should be enabled
  tracePropagationTargets: ['localhost', /^https:\/\/prod\.crownbasenxt\.be/, /^https:\/\/staging\.crownbasenxt\.be/],
});
// Tag events with the deployed build, to see which build a device runs.
const build = getBuildHash();
if (build) Sentry.setTag('build', build);
enableProdMode();

// Hammer is only needed for the swipe gestures on a few screens, so it loads on the first swipe listener instead of at startup.
const browserConfig: ApplicationConfig = {
  providers: [importProvidersFrom(HammerModule), { provide: HAMMER_LOADER, useValue: () => import('hammerjs') }],
};
const config = mergeApplicationConfig(appConfig, browserConfig);
bootstrapApplication(AppComponent, config).catch((err) => console.error(err));
